import { Stack, Image, Text, SimpleGrid, Link } from "@chakra-ui/react";
import React from "react";
import { H3 } from "../Heading";
import { useStore } from "@/store";
import { telemetry } from "@/telemetry";

export const OverdosePlanningCallout = () => {
  const { showLeavingModal } = useStore();

  const handlePlanningToolClick = () => {
    telemetry.trackEvent("reference_link_clicked", {
      link: "overdose_planning_tool",
    });
    showLeavingModal("https://www.nsc.org/overdosetool");
  };

  return (
    <Stack spacing="8">
      <SimpleGrid
        columns={{ base: 1, lg: 2 }}
        spacing={{ base: 8, md: 14 }}
        alignItems="center"
      >
        <Image src="/images/overdose-planning-screens.png" />
        <Stack
          textAlign="center"
          maxWidth={{ base: undefined, lg: "424px" }}
        >
          <H3>
            Looking for guidance on preparing your workplace for an opioid
            overdose?
          </H3>

          <Link
            textDecoration="underline"
            color="primary-light"
            onClick={handlePlanningToolClick}
          >
            <H3>
              Use the National Safety Council’s Overdose Emergency Planning Tool
            </H3>
          </Link>
        </Stack>
      </SimpleGrid>

      <Text textAlign="center">
        The National Safety Council (NSC) received financial support from
        Emergent BioSolutions Inc., to conduct independent research on opioid
        overdose emergency preparedness. Emergent had no role in research
        design, data collection, analysis, or interpretation. The information
        provided by the NSC’s Overdose Emergency Planning Tool is for general
        informational purposes only and is not a substitute for legal or
        regulatory advice. Please consult your own legal counsel for advice
        specific to your situation.
      </Text>
    </Stack>
  );
};
